<div class="mr-4 float-right flex items-center">
    @switch (status()) {
        @case (Deposit.StatusEnum.EXTRACTING) {
            <fa-icon
                size="lg"
                [class]="'text-custom-blue fa-spin'"
                [icon]="['fad', 'spinner-third']"
                [matTooltip]="'extracting' | transloco" />
        }
        @case (Deposit.StatusEnum.IMPORTING) {
            <fa-icon
                size="lg"
                [class]="'text-custom-blue fa-spin'"
                [icon]="['fad', 'spinner-third']"
                [matTooltip]="'importing' | transloco" />
        }
        @case (Deposit.StatusEnum.ABORTED) {
            <fa-icon
                class="text-error"
                size="lg"
                [icon]="['fas', 'xmark']"
                [matTooltip]="'importAborted' | transloco" />
        }
        @case (Deposit.StatusEnum.ERRORED) {
            <fa-icon
                size="lg"
                [class]="'text-custom-red'"
                [icon]="['fad', 'circle-exclamation']"
                [matTooltip]="'errored' | transloco" />
        }
        @case (Deposit.StatusEnum.FAILED) {
            <fa-icon
                size="lg"
                [class]="'text-custom-red'"
                [icon]="['fad', 'triangle-exclamation']"
                [matTooltip]="'failed' | transloco" />
        }
    }

    @if (status() === Deposit.StatusEnum.DONE && (!isValid() || (!!deposit() && !deposit()!.hadDataAtImport))) {
        <fa-icon
            class="text-custom-orange"
            matTooltipClass="whitespace-pre-line"
            size="lg"
            [icon]="['fas', 'triangle-exclamation']"
            [matTooltip]="dataTooltip()" />
    }
</div>
